module.exports = __webpack_public_path__ + "static/media/dns.dff304a1.svg";